// extracted by mini-css-extract-plugin
export default {"wrapper":"_3g8GjfUU","stickySpacer":"hlrQZ1JM","sticky":"_1OU-RYIJ","button":"vgGkKfJ9"};